/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_ResourcesInputs */

const en_landing_footer_resources = /** @type {(inputs: Landing_Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const zh_landing_footer_resources = /** @type {(inputs: Landing_Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Landing_Footer_ResourcesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_resources = /** @type {((inputs?: Landing_Footer_ResourcesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_ResourcesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_resources(inputs)
	return zh_landing_footer_resources(inputs)
});
export { landing_footer_resources as "landing.footer.resources" }